import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";

import store from "./redux/store";
import MessageToaster from "./components/toaster/MessageToaster";

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <AppRoutes />
        <MessageToaster />
      </BrowserRouter>
    </Provider>
  );
}

export default App;